/**
 * 小助理 ·「在约商务」弹窗（商务代言批 2026-10-30 丙工位）：在约品牌长约+挚友活动通告的只读列表。
 * 归属=现实分工（茄子令「对外商务谈判归经纪人，看已签合同的账归助理」）：哪些约、到期、头款尾款。
 * 样板 = CareerRecordPanel（modal-wrap 形制+每开重算）。挚友行显示活动定档，长约行显示剩余月与 5:5 尾款。
 */
import { GameState } from '../../systems/GameState';
import { GameConfig } from '../../core/GameConfig';
import { GameData } from '../../data/GameData';
import { endorsementSystem, ENDORSE_TITLE_NAMES, BRAND_TIER_NAMES, BRAND_CATEGORY_NAMES } from '../../systems/EndorsementSystem';
import { createDiv, createModalDismiss, createSpan } from '../ui';

export class EndorseListPanel {
    readonly element: HTMLElement;
    private readonly listBox: HTMLElement;
    onOpenChanged: ((open: boolean) => void) | null = null;

    constructor() {
        const wrap = createDiv('modal-wrap career-pop');
        const card = createDiv('modal-note-card career-card');
        card.appendChild(createDiv('mtitle', ['在约商务']));
        this.listBox = createDiv('career-body');
        card.appendChild(this.listBox);
        wrap.appendChild(createModalDismiss(() => this.close()));
        wrap.appendChild(card);
        this.element = wrap;
    }

    get isOpen(): boolean {
        return this.element.classList.contains('show');
    }

    open(): void {
        if (this.isOpen) return;
        this.render();
        this.element.classList.add('show');
        this.onOpenChanged?.(true);
    }

    close(): void {
        if (!this.isOpen) return;
        this.element.classList.remove('show');
        this.onOpenChanged?.(false);
    }

    private render(): void {
        this.listBox.innerHTML = '';
        const active = endorsementSystem.activeContracts();
        if (!active.length) {
            this.listBox.appendChild(createDiv('career-empty', ['现在手上没有商务约，报价单来了我叫你。']));
            return;
        }
        for (const c of active) {
            const brand = GameData.BRAND_MAP[c.brandId];
            const item = createDiv('career-item');
            item.appendChild(createDiv('career-line', [
                createSpan('career-title', brand?.name ?? c.brandId),
                createSpan('career-sub', ENDORSE_TITLE_NAMES[c.title]),
                createSpan('career-nums', c.title === 'friend'
                    ? '活动：本月内完成'
                    : `到期：剩 ${c.monthsLeft} 个月`),
            ]));
            item.appendChild(createDiv('career-line', [
                createSpan('career-sub', `${BRAND_TIER_NAMES[c.tier]}品牌 · ${BRAND_CATEGORY_NAMES[c.category] ?? ''}`),
            ]));
            this.listBox.appendChild(item);
        }
    }
}